class Scroll {

	// Properties
	// =========================================================================

	callbacks = [];
	scrolling = false;

	// Constructor
	// =========================================================================

	constructor () {
		Scroll.i = this;

		window.addEventListener('scroll', this.onScroll, false);
	}

	deconstructor () {
		this.callbacks = [];
		this.scrolling = false;
		window.removeEventListener('scroll', this.onScroll, false);
	}

	// Actions
	// =========================================================================

	listen (callback) {
		this.callbacks.push(callback);
	}

	// Events
	// =========================================================================

	onScroll = () => {
		if (this.scrolling)
			return;

		this.scrolling = true;

		requestAnimationFrame(() => {
			this.scrolling = false;
			const percentScrolled = window.scrollY / window.innerHeight
				, distanceScrolled = window.scrollY;
			this.callbacks.forEach(callback => callback(percentScrolled, distanceScrolled));
		});
	};

}

const scroll = new Scroll();
export default scroll;